// Leesona 861 Tackified Winder
import React from "react";
import {
   BeginBackPressureRow, BeginTensionRow, ClockSettingRow, CommonRows, CreelTensionRow,
   GearCRow, GearDRow, GearERow, GearFRow, InputRangeRow, MinMaxRow, RunTimeRow
} from "./index";

export default function Machine861Tack() {
   return (
      <>
         <ClockSettingRow />
         <RunTimeRow />
         <BeginBackPressureRow />
         <BeginTensionRow />
         <InputRangeRow
            titleProp={"Differential Cam Link"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={9}
            propertyNameProp={"diffCamLink"}
            errorDialogueProp={"1-9 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Tension Adjustment Bracket"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={6}
            propertyNameProp={"tensionAdj"}
            errorDialogueProp={"1-6 only"}
            floatProp={false}
         />
         <CreelTensionRow />
         <InputRangeRow
            titleProp={"Yarn Speed"}
            descriptionProp={"ypm"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={1}
            maxProp={500}
            propertyNameProp={"yarnSpeed"}
            errorDialogueProp={"1-500 only"}
            floatProp={false}
         />
         <GearCRow minProp={10} maxProp={30} errorProp={"10-30 only"} />
         <GearDRow minProp={10} maxProp={30} errorProp={"10-30 only"} />
         <GearERow minProp={10} maxProp={30} errorProp={"10-30 only"} />
         <GearFRow minProp={10} maxProp={30} errorProp={"10-30 only"} />
         <InputRangeRow
            titleProp={"Applicator Roll RPM"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={30}
            propertyNameProp={"applicatorRollRPM"}
            errorDialogueProp={"0-30 only"}
            floatProp={true}
         />
         <MinMaxRow
            titleProp={"Wind Ratio"}
            descriptionProp=""
            minProp1={1.0}
            maxProp1={12.99999}
            floatProp1={true}
            errorProp1={"1-12.99999 only"}
            minProp2={1.0}
            maxProp2={12.99999}
            floatProp2={true}
            errorProp2={"1-12.99999 only"}
            valueProp1={"windRatioStart"}
            valueProp2={"windRatioEnd"}
            differentDisplayProp1={"Start:"}
            differentDisplayProp2={"End:"}
         />
         <CommonRows />
      </>
   );
}
